export default "__VITE_ASSET__D1NQE1mG__"